import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaLock,
  FaSignOutAlt,
  FaHome,
  FaShieldAlt,
  FaEnvelope,
} from "react-icons/fa";
import useAuth from "../../useAuth";

export default function UnAuthorized() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    try {
      if (logout) {
        logout();
      }
    } catch (e) {
      console.error(e);
    }
    localStorage.clear();
    navigate("/login", { replace: true });
    if (window.location.pathname !== "/login") {
      window.location.href = "/login";
    }
  };

  return (
    <div className="min-h-[85vh] w-full flex items-center justify-center p-4 sm:p-6 bg-gradient-to-br from-slate-50 via-rose-50/20 to-indigo-50/30 dark:from-slate-950 dark:via-slate-900 dark:to-slate-950 font-sans">
      <div className="relative w-full max-w-lg bg-white/90 dark:bg-slate-900/90 backdrop-blur-xl border border-rose-100 dark:border-rose-950/40 rounded-3xl p-6 sm:p-10 shadow-2xl flex flex-col items-center text-center overflow-hidden animate-in fade-in zoom-in duration-300">
        
        {/* Background Ambient Glows */}
        <div className="absolute -top-24 -left-24 w-48 h-48 bg-rose-500/15 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute -bottom-24 -right-24 w-48 h-48 bg-indigo-500/15 rounded-full blur-3xl pointer-events-none" />

        {/* 403 Floating Badge */}
        <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-rose-100 dark:bg-rose-950/60 text-rose-700 dark:text-rose-300 text-xs font-black tracking-widest uppercase border border-rose-200 dark:border-rose-800/60 mb-6 shadow-xs">
          <FaLock size={10} /> 403 Forbidden Access
        </div>

        {/* Lock / Shield Icon */}
        <div className="relative mb-6">
          <div className="absolute -inset-3 rounded-full bg-gradient-to-r from-rose-500 to-red-600 opacity-20 animate-ping" />
          <div className="relative w-20 h-20 sm:w-24 sm:h-24 bg-gradient-to-tr from-rose-500 via-red-600 to-pink-600 rounded-3xl flex items-center justify-center text-white shadow-xl shadow-rose-500/30">
            <FaShieldAlt className="text-3xl sm:text-4xl" />
            <div className="absolute -bottom-1 -right-1 w-7 h-7 bg-white dark:bg-slate-800 rounded-full flex items-center justify-center text-rose-600 dark:text-rose-400 shadow-md border border-rose-100 dark:border-slate-700">
              <FaLock size={12} />
            </div>
          </div>
        </div>

        {/* Title & Headline */}
        <h1 className="text-2xl sm:text-3xl font-black text-gray-900 dark:text-white tracking-tight mb-2">
          Access Denied
        </h1>

        <p className="text-sm text-gray-600 dark:text-slate-300 font-bold max-w-md mb-4 leading-relaxed">
          Oops! It looks like you don't have the necessary permissions to view this page.
        </p>

        {/* Info Note */}
        <div className="w-full bg-rose-50/70 dark:bg-rose-950/30 border border-rose-200/60 dark:border-rose-900/40 p-3 rounded-2xl text-xs font-semibold text-rose-800 dark:text-rose-300 mb-8 flex items-center gap-2 text-left">
          <FaShieldAlt className="shrink-0 text-rose-500" size={14} />
          <span>
            If you believe this is an error, please contact your administrator to grant page access permissions for your account role.
          </span>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-wrap items-center justify-center gap-3 w-full">
          <button
            onClick={() => navigate(-1)}
            className="flex-1 min-w-[120px] px-4 py-2.5 bg-gray-100 hover:bg-gray-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-gray-800 dark:text-slate-200 rounded-xl font-bold text-xs transition flex items-center justify-center gap-2 shadow-xs"
          >
            <FaArrowLeft size={11} /> Go Back
          </button>

          <button
            onClick={() => navigate("/my")}
            className="flex-1 min-w-[140px] px-4 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-black text-xs transition flex items-center justify-center gap-2 shadow-md shadow-indigo-600/20"
          >
            <FaHome size={12} /> Dashboard
          </button>

          <button
            onClick={handleLogout}
            className="flex-1 min-w-[120px] px-4 py-2.5 bg-rose-600 hover:bg-rose-700 text-white rounded-xl font-black text-xs transition flex items-center justify-center gap-2 shadow-md shadow-rose-600/20"
          >
            <FaSignOutAlt size={12} /> Logout
          </button>
        </div>

        {/* Help Footer */}
        <div className="mt-8 pt-6 border-t border-gray-100 dark:border-slate-800/80 w-full text-[11px] font-semibold text-gray-400 dark:text-slate-500 flex items-center justify-center gap-1.5">
          <FaEnvelope size={10} className="text-gray-400" />
          <span>Need help? Contact support or system administrator.</span>
        </div>

      </div>
    </div>
  );
}


